module.exports = __webpack_public_path__ + "media/images/logo-icon-1281dff701afcf1f2d3a119c3c8379c9.png";